export const attenzioneTruffe = {
  id: 'static-attenzione-truffe',
  slug: 'attenzione-truffe',
  title: 'Attenzione alle Truffe SMS: Proteggi i tuoi dati personali e bancari',
  excerpt: 'Avviso importante sui falsi SMS che sembrano provenire da Nexi e altri istituti bancari. Scopri come proteggerti dalle crescenti minacce digitali.',
  body: `
    <div style="background-color: #f8d7da; color: #721c24; padding: 1.2rem; border-radius: 12px; margin-bottom: 2rem; border-left: 5px solid #f5c6cb; display: flex; align-items: flex-start; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <i class="fas fa-exclamation-triangle" style="font-size: 1.5rem; margin-right: 1rem; margin-top: 0.2rem;"></i>
      <div>
        <p><strong>Avviso importante:</strong> A seguito di una segnalazione nella community WhatsApp, abbiamo deciso di pubblicare questo avviso per informare tutti gli associati su una pericolosa truffa attualmente in circolazione.</p>
        <p style="margin-top: 1rem;">Precisiamo che il messaggio oggetto della truffa non proviene, come erroneamente segnalato, da Infocert. Si tratta di un tentativo di frode messo in atto da soggetti terzi, volto a carpire dati sensibili o a indurre in errore i destinatari.</p>
        <p style="margin-top: 1rem;">Raccomandiamo la massima attenzione e invitiamo a non cliccare su link sospetti e a non fornire dati personali in risposta a messaggi di questo tipo.</p>
        <p style="margin-top: 1rem;"><strong>Per ogni dubbio o ulteriore segnalazione, vi invitiamo a contattare la Segreteria.</strong></p>
      </div>
    </div>

    <h2>Allarme Truffe: Falsi SMS Nexi o altri Istituti Bancari in circolazione</h2>

    <p>Negli ultimi giorni, numerosi utenti ci hanno segnalato di aver ricevuto messaggi SMS fraudolenti che sembrano provenire da Nexi, importante società di servizi di pagamento. Questi messaggi sono in realtà tentativi di <strong>phishing</strong>, progettati per rubare informazioni personali e bancarie.</p>

    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem; margin: 2rem 0;">
      <div style="position: relative; overflow: hidden; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); height: 550px;">
        <img src="/images/truffa-sms.jpg" alt="Esempio di SMS truffa Nexi" style="width: 100%; height: 100%; object-fit: cover; display: block;">
      </div>
      <div style="position: relative; overflow: hidden; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); height: 550px;">
        <img src="/images/truffa_c.png" alt="Donna vittima di truffa online" style="width: 100%; height: 100%; object-fit: cover; display: block;">
        <div style="position: absolute; bottom: 0; left: 0; right: 0; background: rgba(0, 0, 0, 0.7); color: white; padding: 1rem; font-size: 0.9rem;">
          AVVISO PER GLI ASSOCIATI: Prestate attenzione a questi messaggi fraudolenti e informate i vostri clienti
        </div>
      </div>
    </div>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border-radius: 12px; padding: 1.5rem; margin: 2.5rem 0; border-left: 4px solid #00bf8f; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-shield-alt"></i> Cosa sta succedendo?
      </h3>
      <p>Una nuova ondata di truffe SMS sta colpendo gli utenti italiani. I messaggi fraudolenti sembrano provenire da Nexi e avvisano di bonifici sospetti per importi significativi (circa 4.800-5.000 euro), invitando a chiamare urgentemente un numero presentato come "servizio clienti".</p>
    </div>

    <h2>Come si presenta la truffa</h2>
    <p>Il messaggio informa il destinatario di un presunto bonifico sospetto in uscita, per un importo significativo. Il testo è progettato per creare allarme e spingere la vittima ad agire d'impulso, chiamando il numero indicato. Durante la chiamata, i malintenzionati, fingendosi operatori del servizio clienti, cercheranno di ottenere:</p>
    <ul>
      <li>Credenziali di accesso ai servizi bancari online</li>
      <li>Numeri completi di carte di credito/debito</li>
      <li>Codici di sicurezza e PIN</li>
      <li>Dati personali sensibili</li>
    </ul>

    <h2>Come proteggersi</h2>
    <p>Per evitare di cadere vittima di queste truffe, è importante seguire alcune semplici regole:</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border-radius: 12px; padding: 1.5rem 1.5rem 1.5rem 3rem; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08); margin: 2rem 0;">
      <ul>
        <li style="margin-bottom: 1rem;"><strong>Non rispondere mai</strong> a messaggi sospetti e non chiamare i numeri in essi contenuti</li>
        <li style="margin-bottom: 1rem;"><strong>Non cliccare su link</strong> presenti nei messaggi</li>
        <li style="margin-bottom: 1rem;"><strong>Verificare sempre</strong> lo stato del proprio conto attraverso i canali ufficiali (app o sito web della banca, digitando manualmente l'indirizzo)</li>
        <li style="margin-bottom: 1rem;">In caso di dubbi, <strong>contattare direttamente la propria banca</strong> utilizzando i numeri ufficiali presenti sul retro della carta o sul sito ufficiale</li>
        <li style="margin-bottom: 1rem;"><strong>Segnalare</strong> i messaggi sospetti alla Polizia Postale tramite il sito www.commissariatodips.it</li>
      </ul>
    </div>

    <h2>Un fenomeno in crescita</h2>
    <p>Le truffe via SMS, conosciute come "smishing" (SMS + phishing), sono in costante aumento. I cybercriminali stanno perfezionando le loro tecniche, utilizzando nomi di aziende affidabili e creando messaggi sempre più convincenti.</p>

    <div style="background: linear-gradient(135deg, rgba(0, 191, 143, 0.05) 0%, rgba(0, 21, 16, 0.02) 100%); border-radius: 12px; padding: 1.5rem; margin: 2.5rem 0; border-left: 4px solid #00bf8f; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);">
      <h3 style="color: #00bf8f; margin-bottom: 1rem; font-size: 1.3rem;">
        <i class="fas fa-lightbulb"></i> Ricorda sempre
      </h3>
      <p><strong>Nessuna banca o istituto finanziario richiederà mai</strong> dati sensibili via SMS, email o telefono. In caso di comunicazioni sospette, è sempre meglio verificare direttamente attraverso i canali ufficiali.</p>
    </div>

    <p>È fondamentale mantenere alta l'attenzione e diffondere queste informazioni tra familiari, amici e colleghi, specialmente tra le persone meno esperte di tecnologia che potrebbero essere più vulnerabili a questi attacchi.</p>

    <p>La sicurezza online è una responsabilità condivisa: informarsi e prestare attenzione è il primo passo per proteggere sé stessi e gli altri da queste minacce digitali sempre più diffuse.</p>
  `,
  featuredImage: '/images/truffa_c.png',
  category: {
    id: 'sicurezza',
    name: 'Sicurezza',
    slug: 'sicurezza',
    color: '#EF4444'
  },
  tags: ['Truffe', 'Phishing', 'SMS', 'Sicurezza Online', 'Nexi', 'Smishing'],
  author: {
    id: 'unasca-admin',
    username: 'UNASCA',
    profile: {
      firstName: 'UNASCA',
      lastName: 'Nazionale',
      fullName: 'UNASCA Nazionale'
    }
  },
  status: 'PUBLISHED' as const,
  visibility: 'PUBLIC' as const,
  publishedAt: '2025-05-18T10:00:00Z',
  createdAt: '2025-05-18T10:00:00Z',
  updatedAt: '2025-05-18T10:00:00Z',
  metadata: {
    views: 0,
    likeCount: 0,
    shares: 0
  },
  readingTime: 4
};

